class Megamenu extends HTMLElement {
  constructor() {
    super();
    this.currentHoveredItem = null;
  }

  connectedCallback() {
    if (!this.isAddedToHeader()) {
      this.addMeganavToHeader();
      this.setupEventListeners();
    }
  }

  isAddedToHeader() {
    return document.querySelector('.header-wrapper megamenu-nav') !== null;
  }

  addMeganavToHeader() {
    const headerWrapper = document.querySelector('.section-header .header-wrapper');
    headerWrapper.appendChild(this);
  }

  setupEventListeners() {
    document.querySelectorAll('.nav-target').forEach((navTarget) => {
      navTarget.addEventListener('mouseover', (event) => this.handleMouseOver(navTarget, event));
    });

    document.addEventListener('mouseover', (event) => this.hideMenuItems(event));
  }

  handleMouseOver(navTarget, event) {
    const targetValue = navTarget.getAttribute('data-item-handle');
    const modifiedTargetValue = `megamenu-${targetValue}`;
    const relatedMegamenuItem = this.querySelector(`megamenu-item[id="${modifiedTargetValue}"]`);

    if (this.currentHoveredItem && this.currentHoveredItem !== relatedMegamenuItem) {
      this.currentHoveredItem.classList.remove('is_visible');
      document.body.classList.remove('megamenu-is-active');
    }

    if (relatedMegamenuItem) {
      relatedMegamenuItem.classList.add('is_visible');
      document.body.classList.add('megamenu-is-active');
      this.currentHoveredItem = relatedMegamenuItem;
    } else {
      this.currentHoveredItem = null; // Reset the current hovered item
    }

    event.stopPropagation();
  }

  hideMenuItems(event) {
    const headerWrap = document.querySelector('.header-wrap');
    const megamenuCurtain = document.querySelector('megamenu-curtain');
    const isOutsideHeaderWrap = !headerWrap.contains(event.target);
    const megamenuItems = this.querySelectorAll('megamenu-item.is_visible');
    if (isOutsideHeaderWrap && megamenuItems || event.target == megamenuCurtain ) {
      megamenuItems.forEach((item) => {
        if (item.classList.contains('is_visible')) {
          item.classList.remove('is_visible');
          document.body.classList.remove('megamenu-is-active');
          this.currentHoveredItem = null; // Reset the current hovered item
        }
      });
    }
  }
}

customElements.define('megamenu-nav', Megamenu);
